<template>
  <div>
<div class="aboutuspage-style" v-if="isMobile">
  <toppage></toppage>
      <div class="aboutuspage-main">
        <div class="mian-header">
          <div class="header-content">
            <h1>公司介绍</h1>
            <p>成都北鸣电子科技有限公司（以下简称“北鸣”）于2022年在四川成都正式成立，是专家级区块链虚拟货币追溯及安全解决方案供应商。 </p>
                 <p>

北鸣依托对区块链安全技术及其应用场景的理解，融入云计算、大数据、AI等技术，自研打造链上安全生态体系，进行虚拟货币溯源分析及区块链安全生态解决方案的研发，构建链上数据分析、货币溯源挽损、安全风险管控一体化服务模式，为公安及监管机构、企业等各级客户护航链上安全。 

</p>
<p>北鸣理解行业之需，将大数据、人工智能等核心技术成果与应用场景结合，在案件配侦等领域持续发力。目前全球范围内超200+客户，业务覆盖安全审计、威胁情报、防御部署等服务，并配套有图链虚拟货币安全智能研判系统、加密货币反洗钱（AML）等安全产品，与浙江、云南、贵州、河南、山东、湖北、湖南、江西等政府机构、公安单位建立良好合作关系，获得业界的广泛认可。 </p>
           
          </div>
        </div>
          <div class="main-secure">
          <img src="@/assets/image/mobile/abouts/aboutus2.png" alt="">
          <h1>图链&nbsp; &nbsp;「链接·无限安全」</h1>
          <p>
                    区块链技术为全球范围内的资金流动提供了便利，同时也带来了洗钱、诈骗等非法活动的风险。因此，需要通过强大的数据分析、智能溯源追踪等技术手段，对链上资金进行追踪取证、调查分析，以便及时发现和制止链上非法交易活动。
                    </p>
                    <p>  &nbsp; &nbsp; </p>
                 
<p>未来，我们将持续深化警企合作，深入理解行业需求，依托自身优势和实战经验，协助各级执法机关、监管机构共同打击涉虚拟货币犯罪，为区块链世界的交易保驾护航。确保区块链交易的安全性和可靠性，创造一个健康、稳定的环境。
                  </p>
          </div>
          <div class="main-secure1">
          <img src="@/assets/image/mobile/abouts/aboutus3.png" alt="">
          <h1>您身边的区块链交易安全专家</h1>
      <p>您身边的区块链交易安全专家</p>
          </div>
          <div class="main-secure2">
          <img src="@/assets/image/mobile/abouts/aboutus1.png" alt="">
          <h1>创新链接，智造无限可能</h1>
      <p>成为全球领先的区块链安全生态开拓者和领导者</p>
          </div>
        <footerpage></footerpage>
      </div>
      <img class="scroll-button" v-if="showButton"  @click="scrollToTop" src="../../assets/image/newhome/huidaodingbu.png" alt="">

</div>
    <div class="aboutuspage-style" v-else>
      <full-page :options="options" ref="fullpage">
        <div class="section aboutuspage-top  " >
          <div >

            <div class="aboutuspage-nav ">
              <navbar classname="aboutus"></navbar>
            </div>
            <div class="section-content ">
              <div class="top-title">
                <div class="title-info">
                  <h1>公司介绍</h1>
                <div class="title-content">

                  <p>成都北鸣电子科技有限公司（以下简称“北鸣”）于2022年在四川成都正式成立，是专家级区块链虚拟货币追溯及安全解决方案供应商。 </p>
                 <p>

北鸣依托对区块链安全技术及其应用场景的理解，融入云计算、大数据、AI等技术，自研打造链上安全生态体系，进行虚拟货币溯源分析及区块链安全生态解决方案的研发，构建链上数据分析、货币溯源挽损、安全风险管控一体化服务模式，为公安及监管机构、企业等各级客户护航链上安全。 

</p>
<p>北鸣理解行业之需，将大数据、人工智能等核心技术成果与应用场景结合，在案件配侦等领域持续发力。目前全球范围内超200+客户，业务覆盖安全审计、威胁情报、防御部署等服务，并配套有图链虚拟货币安全智能研判系统、加密货币反洗钱（AML）等安全产品，与浙江、云南、贵州、河南、山东、湖北、湖南、江西等政府机构、公安单位建立良好合作关系，获得业界的广泛认可。 </p>
                </div>
                </div>
              
                <!-- <div class="judiciary-button animated-element1">
                  <span>司法协助</span>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="section aboutuspage-secure">
          <div class="secure-content animated-element1" v-show="issecure">
            <div class="secure-box">
              <div class="secure-main">
                <div class="secure-info  ">

                  <h1>图链&nbsp; &nbsp;「链接·无限安全」</h1>
                  <p>
                    区块链技术为全球范围内的资金流动提供了便利，同时也带来了洗钱、诈骗等非法活动的风险。因此，需要通过强大的数据分析、智能溯源追踪等技术手段，对链上资金进行追踪取证、调查分析，以便及时发现和制止链上非法交易活动。
                    </p>
                    <p>  &nbsp; &nbsp; </p>
                 
<p>未来，我们将持续深化警企合作，深入理解行业需求，依托自身优势和实战经验，协助各级执法机关、监管机构共同打击涉虚拟货币犯罪，为区块链世界的交易保驾护航。确保区块链交易的安全性和可靠性，创造一个健康、稳定的环境。
                  </p>
                 
                </div>
            <div class="secure-liucheng">
    
        <img src="../../assets/image/newhome/aboutus/aboutus2.png" alt="">
            </div>
      
              </div>
           
            </div>
           
          </div>
        </div>
      
        <div class="section aboutuspage-secure1">
          <div class="secure-content animated-element1" v-show="issecure1">
            <div class="secure-box">
              <div class="secure-main">
           
            <div class="secure-liucheng">
    
        <img src="../../assets/image/newhome/aboutus/aboutus3.png" alt="">
            </div>
            <div class="secure-info  ">

<h1>您身边的区块链交易安全专家</h1>
<h2>以科技赋能链上安全交易体验</h2>
</div>
              </div>
           
            </div>
           
          </div>
        </div>
        <div class="section aboutuspage-secure2">
          <div class="secure-content animated-element1" v-show="issecure2">
            <div class="secure-box">
              <div class="secure-main">
                <div class="secure-info  ">
                  <h1>创新链接，智造无限可能 </h1>
                <h2>成为全球领先的区块链安全生态开拓者和领导者</h2>
                 
</div>
            <div class="secure-liucheng">
    
        <img src="../../assets/image/newhome/aboutus/aboutus2.png" alt="">
            </div>
      
              </div>
           
            </div>
            <div class="profession-bottom">
              <newfooter></newfooter>
            </div>
          </div>
        </div>
        <!-- <div class="section aboutuspage-profession">
          <div class="profession-content animated-element1" v-show="isprofession">
            <div class="profession-box">
              <div class="profession-main">
                <div class="profession-info  ">

                  <h1>服务流程</h1>
                 
                </div>
            <div class="profession-liucheng">
              <img src="../../assets//image/newhome/securityaudit/liucheng.png" alt="">
              <div class="liucheng-content">
                <span >业务沟通</span>
                <span>项目评估</span>

                <span>支付费用</span>
                <span>安全审计</span>

                <span>出具报告</span>

              </div>
            </div>
            <div class="liucheng-button">
              <span>联系我们</span>
            </div>
              </div>
           
            </div>
            <div class="profession-bottom">
              <newfooter></newfooter>
            </div>
          </div>
        </div> -->
      </full-page>
      <div></div>
    </div>
  </div>
  </template>
  <script>
  import navbar from "@/components/navbar.vue";
  import newfooter from "@/components/newfooter.vue";
  // import countTo  from 'vue-count-to';
  // import CountUp from "countup"
  import toppage from "@/views/newhome/toppage.vue";
import footerpage from "@/views/newhome/footerpage.vue";
  export default {
    components: {
      navbar,
      newfooter,
      toppage,
    footerpage,
      // countTo 
    },
    data() {
      return {
        deviceType: this.getDeviceType(),
        showButton: false,
      scrollThreshold: 400,
      isMobile: false,
        // isshebi:false,
        issecure:false,
        issecure1:false,
        issecure2:false,
     
        isprofession:false,
       
        options: {
          licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
          //是否显示导航，默认为false
          navigation: true,
   afterLoad: this.afterLoad,
   onLeave:this.onLeave,

          //为每个section设置背景色
          // sectionsColor: [
          //     "#41b883",
          //     "#ff5f45",
          //     "#0798ec",
          //     "#fec401",
          //     "#1bcee6",
          //     "#ee1a59",
          //     "#2c3e4f",
          //     "#ba5be9",
          //     "#b4b8ab"
          // ],
        },
      };
    },
    methods: { 
        scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
      getDeviceType() {
      return window.innerWidth < 768 ? "手机" : "电脑";
    },
    handleResize() {
      this.deviceType = this.getDeviceType();
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 1199;
    },
    //   onLeave(index, direction){
    //   console.log(index, direction);
    // },
      afterLoad(anchorLink,index) {
        console.log(anchorLink,index);
          console.log("Emitted 'after load' event.")
          //获取body的classname，跟随section滑动刷新
          let a = document.body.className
          console.log(a);
          //在第几页控制相关逻辑
          if(a !== 'fp-scroll-mac fp-viewing-1' || a !== 'fp-viewing-1'){
            this.issecure=false
          }
          if(a !== 'fp-scroll-mac fp-viewing-2' || a !== 'fp-viewing-2'){
            this.issecure1=false
          }
          if(a !== 'fp-scroll-mac fp-viewing-3' || a !== 'fp-viewing-3'){
            this.issecure2=false
          }
          // if(a !== 'fp-scroll-mac fp-viewing-4' || a !== 'fp-viewing-4'){
          //   this.isprofession=false
          // }
          if (a === 'fp-scroll-mac fp-viewing-3' || a === 'fp-viewing-3') {
            // console.log(eee);
            this.issecure2=true
     
        }
        else if(a === 'fp-scroll-mac fp-viewing-1' || a === 'fp-viewing-1'){
          this.issecure=true
        }
        else if(a === 'fp-scroll-mac fp-viewing-2' || a === 'fp-viewing-2'){
          this.issecure1=true
        }
        // else if(a === 'fp-scroll-mac fp-viewing-3' || a === 'fp-viewing-3'){
        //   this.issecure2=true
        // }
        },
  
   
      next() {
        // 向下滚动一页
        this.$refs.fullpage.api.moveSectionUp();
// this.$refs.fullpage.goTo(0);
      },
    },
    // created(){     location.reload()},
    mounted() {
      if (this.deviceType != "手机" && !this.isMobile) {
      this.next();
    }

    if(this.isMobile){

window.addEventListener('scroll', () => {
  this.showButton = window.scrollY > this.scrollThreshold;
});
}
      
      
    },
    created() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener('scroll', () => {});
  },
  };
  </script>
  <style>
  .fp-warning,
  .fp-watermark {
    display: none !important;
  }
  </style>
  
  <style lang="scss" scoped>
  @import "@/assets/scss/aboutuspage.scss";
  </style>
  